import { render, staticRenderFns } from "./FrontHome.vue?vue&type=template&id=457ea2c1&"
import script from "./FrontHome.vue?vue&type=script&lang=js&"
export * from "./FrontHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports